<template>
    <div>
        <div>
            <!--button regresar-->
            <vs-button color="#f5f5f5" style="color:#1872DF;" class="vs-button mt-3 p-2" @click="$emit('changeHandle',0);">← Volver</vs-button>
            <div v-if="menu == 0">
                <EvaluacionResueltasListadoVue :ObjectSelected="ObjectSelected"/>
            </div>
        </div>
    </div>
</template>
<script>
const EvaluacionResueltasListadoVue = () => import('./EvaluacionResueltasListado.vue');
export default {
    components:{
        EvaluacionResueltasListadoVue
    },
    data() {
       return{
            menu:0,
       } 
    },
    props:{
        ObjectSelected:{
            type:Object,
            required:true,
            default:()=>{}
        }
    }
}
</script>